/**
 * Copyright 2026 ForgeRock AS. All Rights Reserved
 *
 * Use of this code requires a commercial software license with ForgeRock AS
 * or with one of its affiliates. All use shall be exclusively subject
 * to such license between the licensee and ForgeRock AS.
 */

export default [
  {
    path: '/',
    redirect: '/dashboard/overview',
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/IDM/IDMLogin'),
    meta: { hideNavBar: true, hideSideMenu: true },
  },
  {
    path: '/dashboard/overview',
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: () => import('@/views/IDM/Dashboard'),
      },
    ],
  },
  {
    path: '/provisioners',
    children: [
      {
        path: '',
        name: 'Provisioners',
        component: () => import('@/views/Provisioners/ListProvisioners'),
      },
      {
        path: ':provisionerName/:objectTypeName?/:objectTypeTab?',
        name: 'EditProvisioner',
        component: () => import('@/views/Provisioners/EditProvisioner'),
      },
      {
        path: ':provisionerName/:objectTypeName/:objectTypeTab/:mappingName',
        name: 'SyncDataProvisionerEditor',
        component: () => import('@/components/AdvancedSync/SyncDataEdit/SyncDataEditor'),
        meta: { hideNavBar: true, hideSideMenu: true },
      },
    ],
  },
  {
    path: '/jobs',
    name: 'Jobs',
    component: () => import('@/views/Jobs'),
  },
  {
    path: '/configure',
    children: [
      {
        path: '',
        name: 'ConfigureManaged',
        component: () => import('@/views/ConfigureManaged/ConfigureManaged'),
      },
      {
        path: ':managedId/:tab?',
        name: 'ManagedObjectSettings',
        component: () => import('@/views/ConfigureManaged/ManagedObjectSettings'),
      },
      {
        path: ':managedId/Relationships/:propertyName',
        name: 'RelationshipEdit',
        component: () => import('@/views/ConfigureManaged/RelationshipsTab/RelationshipWizard'),
        meta: { hideNavBar: true, hideSideMenu: true },
      },
      {
        path: ':managedId/Properties/:propertyName',
        name: 'ManagedObjectEditProperty',
        component: () => import('@/views/ConfigureManaged/PropertiesTab/PropertyWizard'),
        meta: { hideNavBar: true, hideSideMenu: true },
      },
      {
        path: ':objectTypeName/:tab/:mappingName',
        name: 'SyncIdentityProfileEditor',
        component: () => import('@/components/AdvancedSync/SyncDataEdit/SyncDataEditor'),
        meta: { hideNavBar: true, hideSideMenu: true },
      },
    ],
  },
  {
    path: '/managed-identities/:resourceType?/:resourceName?',
    children: [
      {
        path: '',
        name: 'ManagedIdentities',
        component: () => import('@/views/ManagedIdentities'),
        strict: true,
      },
      {
        path: ':resourceId',
        name: 'EditResource',
        component: () => import('@/views/ManagedIdentities/EditResourceView'),
        meta: { authenticate: true, listRoute: 'managed-identities' },
      },
    ],
  },
  {
    path: '/connect/:listType?',
    children: [
      {
        path: '',
        name: 'Connect',
        component: () => import('@/views/Connect'),
      },
      {
        path: 'connector-servers/:serverName/:tab',
        name: 'EditConnectorServer',
        component: () => import('@/views/Connect/ConnectorServers/EditConnectorServer'),
      },
      {
        path: 'server-clusters/:clusterName/:tab',
        name: 'EditServerCluster',
        component: () => import('@/views/Connect/ServerClusters/EditServerCluster'),
      },
    ],
  },
  {
    path: '/import',
    name: 'BulkImport',
    component: () => import('@/views/BulkImport'),
  },
  {
    path: '/events',
    name: 'Events',
    component: () => import('@/views/Events'),
  },
  {
    path: '/email/templates',
    name: 'EmailTemplates',
    component: () => import('@/views/Email/Templates'),
  },
  {
    path: '/email/templates/edit/:templateId',
    name: 'EditEmailTemplate',
    component: () => import('@/views/Email/Templates/EditEmailTemplate'),
    meta: { hideNavBar: true, hideSideMenu: true },
  },
  {
    path: '/email/provider',
    name: 'EmailProvider',
    component: () => import('@/views/Email/Provider'),
  },
  {
    path: '/customEndpoints',
    name: 'CustomEndpoints',
    component: () => import('@/views/CustomEndpoints'),
  },
];
